import { useState, useEffect } from 'react';
import { useGetState } from 'ahooks';
import 'js-cookie';
import '../../constants/login.js';
import '../../constants/activity.js';
import '../../constants/common.js';
import { insertScript } from '../../utils/insertScript.js';
import 'validator';
import '../../utils/serverTime.js';
import 'crypto-js/sha256';
import 'crypto-js/enc-base64';
import 'crypto-js/hmac-sha256';
import '../../utils/rbacErrorHandler.js';

/* eslint-disable react-func/max-lines-per-function */
const CAPTCHA_ID = 'cce887d475a544f881f1e7a1b31afc2f';
const useNECaptcha = (options) => {
    const [captchaIns, setCaptchaIns, getCaptchaIns] = useGetState();
    const [validate, setValidate] = useState(undefined);
    useEffect(() => {
        const init = () => window?.initNECaptchaWithFallback?.({
            captchaId: CAPTCHA_ID,
            element: '#captcha',
            lang: 'zh-CN',
            onVerify: function (err, data) {
                if (err) {
                    setValidate('');
                }
                else {
                    setValidate(data?.validate);
                }
            },
            ...options,
        }, function onload(instance) {
            setCaptchaIns(instance);
        }, function onerror(err) {
            // 初始化失败后触发该函数，err对象描述当前错误信息
            // eslint-disable-next-line no-console
            console.warn(err);
        });
        if (!!window.initNECaptchaWithFallback) {
            init();
        }
        else {
            insertScript('https://static.fuxi.netease.com/yaotai/static/js/yidun-captcha.js')
                .then(() => {
                init();
                // eslint-disable-next-line no-console
            })
                .catch(err => console.log(err));
        }
    }, [JSON.stringify(options)]);
    return {
        captchaIns,
        validate,
        getCaptchaIns,
    };
};

export { useNECaptcha as default, useNECaptcha };
